class Conf {
  Timeout: number = 3000
  DownloadTimeout: number = 10 * 60 * 1000
  ExceptionCodeMsg: any = {
    'exception:400': '错误请求！',
    'exception:401': '未授权，请重新登录！',
    'exception:403': '拒绝访问，请先获取权限！',
    'exception:404': '请求页面不存在！',
    'exception:405': '请求方法未允许！',
    'exception:406': '无法访问服务器！',
    'exception:408': '请求超时了！',
    'exception:422': '请求参数有误！',
    'exception:500': '服务器出错了！',
    'exception:502': '服务器连接超时！',
    'exception:503': '服务不可用！',
    'exception:504': '网络超时了！'
  }
  baseUrl() {
    return process.env.VUE_APP_API_URL
  }
}
export default new Conf()
